/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { useCallback, useState } from "react";
import { pdfjs, Document, Page } from "react-pdf";
import { useIntersectionObserver } from "@wojtekmaj/react-hooks";
import { connect } from 'react-redux';
import {Spin} from 'antd';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const observerConfig = {
    // How much of the page needs to be visible to consider page visible
    threshold: 0
};
function PageWithObserver({ pageNumber, setPageVisibility, ...otherProps }) {
    const [page, setPage] = useState();
    const onIntersectionChange = useCallback(
        ([entry]) => {
            setPageVisibility(pageNumber, entry.isIntersecting);
        },
        [pageNumber, setPageVisibility]
    );

    useIntersectionObserver(page, observerConfig, onIntersectionChange);
    return <Page canvasRef={setPage} pageNumber={pageNumber}  {...otherProps}>  </Page>;
}

function PDFView(props) {
    const [numPages, setNumPages] = useState(null);
    const [visiblePages, setVisiblePages] = useState({});
    const onDocumentLoadSuccess = (pdf) => { setNumPages(pdf?.numPages); };

    const setPageVisibility = useCallback((pageNumber, isIntersecting) => {
        setVisiblePages((prevVisiblePages) => ({ ...prevVisiblePages, [pageNumber]: isIntersecting }));
    }, []);

    return (
        <>
            { props.documentSelected && (
                
                <>
                    <Document file={props.documentSelected.storageUrl} onLoadSuccess={onDocumentLoadSuccess} loading={<Spin />}>
                    
                        {Array.from(new Array(numPages), (el, index) => (
                            <PageWithObserver  
                                key={`page_${index + 1}`}
                                pageNumber={index + 1}
                                setPageVisibility={setPageVisibility}
                                visiblePages={visiblePages}/>
                        ))}
                    </Document>
                </>
            )
            }
        </>
    );
}
const mapStateToProps = (state) => {
    return {
        documentSelected: state.LegalDocumentsReducer.documentSelected,
    };
};

export default connect(mapStateToProps)(PDFView);
